/* eslint-disable @typescript-eslint/no-unused-vars */
import { Action, PayloadAction } from '@reduxjs/toolkit';
import { Epic, StateObservable, ofType } from 'redux-observable';
import { Observable, catchError, concatMap, from, of } from 'rxjs';

import { Dependencies } from '@configurations/dependencies/dependencies';
import { RootState } from '@store/create-store';
import {
  retrieveHourlyRequestFilteredBasecaseIdsSuccess,
  retrieveHourlyRequestFilteredReferentialsIdsFailure,
  retrieveHourlyRequestFilteredSourceIdsSuccess,
  retrieveHourlyRequestFilteredWeatherYearIdsSuccess,
  retrieveHourlyRequestFilteredZoneIdsSuccess,
} from '@store/scenario/hourly-request-filtered-referentials/hourly-request-filtered-referentials-ids-slice';
import { HourlyRequestFilteredReferentialsIds } from '@scenario/models/hourly-request-filtered-referentials-ids.model';
import { Filters } from '@scenario/enums/filters.enum';

export const retrieveHourlyRequestFilteredReferentialsIdsEpic: Epic<Action, Action, RootState, Dependencies> = (
  action$: Observable<Action>,
  _state$: StateObservable<RootState>,
  dependencies: Dependencies,
) =>
  action$.pipe(
    ofType('hourlyRequestFilteredReferentialsIds/retrieveHourlyRequestFilteredReferentialsIds'),
    concatMap((action: PayloadAction<{inactiveFields: (keyof HourlyRequestFilteredReferentialsIds)[], filteredReferentialsIds: HourlyRequestFilteredReferentialsIds}>) =>
      from(dependencies.hourlyRequestFilteredReferentialsIdsGateway.retrieveAllIds(action.payload.filteredReferentialsIds)).pipe(
        concatMap((filteredReferentialsIds: HourlyRequestFilteredReferentialsIds) =>
          from(action.payload.inactiveFields.flatMap((field: keyof HourlyRequestFilteredReferentialsIds) => {
            const lowerField = field.toLocaleLowerCase();

            if (lowerField.includes(Filters.REGION.toLocaleLowerCase())) {
              return retrieveHourlyRequestFilteredZoneIdsSuccess(filteredReferentialsIds.zoneIds);
            }
            if (lowerField.includes(Filters.SOURCE.toLocaleLowerCase())) {
              return retrieveHourlyRequestFilteredSourceIdsSuccess(filteredReferentialsIds.sourceIds);
            }
            if (lowerField.includes(Filters.BASECASE.toLocaleLowerCase())) {
              return retrieveHourlyRequestFilteredBasecaseIdsSuccess(filteredReferentialsIds.basecaseIds);
            }
            if (lowerField.includes(Filters.WEATHER_YEAR.toLocaleLowerCase().split('_')[0])) {
              return retrieveHourlyRequestFilteredWeatherYearIdsSuccess(filteredReferentialsIds.weatherYearIds);
            }
            return [];
          }))
        ),
        catchError(() => of(retrieveHourlyRequestFilteredReferentialsIdsFailure('Fail to retrieve hourly request filtered referentials ids'))),
      ),
    ),
  );
